import { render, staticRenderFns } from "./trip-list-page.vue?vue&type=template&id=7c4cf8ae&scoped=true&"
import script from "./trip-list-page.vue?vue&type=script&lang=js&"
export * from "./trip-list-page.vue?vue&type=script&lang=js&"
import style0 from "./trip-list-page.vue?vue&type=style&index=0&id=7c4cf8ae&lang=scss&scoped=true&"
import style1 from "./trip-list-page.vue?vue&type=style&index=1&id=7c4cf8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4cf8ae",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTabs,QTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTabs,QTab,QTabPanels,QTabPanel})
